import {
  Menu,
  Text,
  Box,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import { AccountSelectionHeaderProps } from 'types/plaid';

import { defaultPlaidInstitutionLogo } from '../constants';
import { ImageWithFallback } from '../ImageWithFallback';
import { InvalidateItemModal } from './InvalidateItemModal';
import { Icon } from '~/packages/common-frontend/components/icons';

export const AccountSelectionHeader = ({
  institutionWithAccounts,
  refreshAccounts,
}: AccountSelectionHeaderProps) => {
  const { logoUrl, name, itemId: plaidItemId } = institutionWithAccounts;
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Refresh button intentionally wrapped in span to resolve chakru-ui issue
  // https://github.com/chakra-ui/chakra-ui/issues/500
  return (
    <Box>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="left"
      >
        <Box display="flex" alignItems="center">
          <ImageWithFallback
            fallbackUrl={defaultPlaidInstitutionLogo}
            height={32}
            width={32}
            defaultUrl={logoUrl}
            alt="Logo"
          />
          <Text fontWeight="bold" ml="10px">
            {name}
          </Text>
        </Box>
        <Box marginLeft="auto" marginRight="25px">
          <Menu>
            <MenuButton>
              <Icon icon="gear" />
            </MenuButton>
            <MenuList>
              <MenuItem
                onClick={() => {
                  refreshAccounts();
                }}
              >
                Refresh Accounts
              </MenuItem>
              <MenuItem onClick={onOpen}>Remove Connection</MenuItem>
            </MenuList>
          </Menu>
          <InvalidateItemModal
            isOpen={isOpen}
            onClose={onClose}
            name={name}
            plaidItemId={plaidItemId}
          />
        </Box>
      </Box>
    </Box>
  );
};
